import React, {Component} from 'react'
import Panel from '../Panel'
import {style, media, merge} from 'glamor'
import * as colors from '../../colors'
import Page from './Page'
import PageTitle from '../PageTitle'
import SectionTitle from '../SectionTitle'
import Flickity from '../Flickity'
import {ButtonCircle} from 'rebass'
import {Arrow} from 'reline'
import loopIndex from '../../utils/loopIndex'

const SlideTitle = (item) => (
  <div
    className="cell"
    {...style({
      width: '100%',
      padding: '1.5rem'
      // filter: 'grayscale(100%) contrast(125%)',
    })}
  >
    <SectionTitle>
      {item.title}
    </SectionTitle>
    <div>
      {item.description}
    </div>
  </div>

)

const Slide = ({image}) => (
  <div
    {...merge(
      style({
        width: '100%',
        height: '100%',
        // padding: '0.5rem',
      }),
      media('(min-width:800px)', {
        // padding: '1.5rem',
      })
    )}
    className="cell"
  >
    <div
      {...style({
        width: '100%',
        height: '100%',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url(${image})`,
        // filter: 'grayscale(100%) contrast(125%)',
      })}
    />
  </div>

)

export default class extends Component {

  constructor(props){
    super(props)
    this.handleSelect = this.handleSelect.bind(this)
    this.prev = this.prev.bind(this)
    this.next = this.next.bind(this)
    this.state = {
      selected: 0
    }
  }


  handleSelect(i){
    console.log('select', i)
    this.setState({selected: i})
  }

  prev(){
    console.log('prev')
    this.setState({
      selected: loopIndex(this.state.selected - 1, this.props.items.length)
    })
  }

  next(){
    console.log('next')
    this.setState({
      selected: loopIndex(this.state.selected + 1, this.props.items.length)
    })
  }

  // shouldComponentUpdate(){
  //   return false
  // }

  render(){
    const {items} = this.props
    return (
      <Page
        {...merge(
          style({
          }),
          media('(min-width:800px)', {
            display: 'block',
            height: '100%',
            paddingTop: '4rem',
            paddingBottom: '4rem',
            display: 'flex'
          })
        )}
      >
          <PageTitle >Conseil</PageTitle>

          <div
            {...merge(
              style({
                marginBottom: '1.5rem',
              }),
              media('(min-width:800px)', {
                marginBottom: 0,
                marginRight: '4rem',
                width: '50%',
                height: '100%',
                display: 'flex',
                alignItems: 'center'
              })
            )}
          >
            <div
              {...style({
                width: '100%'
              })}
            >
              <Panel
                data-animate
                style={{
                  width: '100%',
                  padding: 0,
                  marginBottom: '1.5rem',
                }}
              >
                <Flickity
                  selected={this.state.selected}
                  onSelect={this.handleSelect}
                  options={{
                    setGallerySize: true
                  }}
                  {...merge(
                    style({
                      width: '100%',
                    }),
                    media('(min-width:800px)', {
                    })
                  )}
                >
                  { items.map((item, i) => <SlideTitle key={i} {...item}/>)}
                </Flickity>
              </Panel>
              <div
                  data-animate
                {...merge(
                  style({
                    textAlign: 'center'
                  }),
                  media('(min-width:800px)', {
                    textAlign: 'left'
                  })
                )}
              >
                <ButtonCircle
                  style={{
                    marginRight: '0.5rem'
                  }}
                  onClick={this.prev}
                  size={40}
                  color={colors.white}
                  backgroundColor={colors.yellow}
                >
                  <Arrow left strokeWidth={2}/>
                </ButtonCircle>
                <ButtonCircle
                  onClick={this.next}
                  size={40}
                  color={colors.white}
                  backgroundColor={colors.yellow}
                >
                  <Arrow right strokeWidth={2}/>
                </ButtonCircle>
              </div>
            </div>
          </div>

          <Flickity
            selected={this.state.selected}
            onSelect={this.handleSelect}
            data-animate
            {...merge(
              style({
                width: '100%',
                height: '300px',
                // background: colors.black05
                // border: `1px solid ${colors.black05}`
              }),
              media('(min-width:800px)', {
                height: '100%',
                flex: '1 1 auto'
              })
            )}
          >
            { items.map(({images}, i) => <Slide key={i} image={images[0].src}/>)}
          </Flickity>
      </Page>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/pages/Conseil.js
 **/